<template>
    <div id="Step3">

<div class="small-12 columns payment-summary">
		<p class="title">Payment summary</p>
		<div class="summary-pack" v-if="packages.length > 1">
			<div class="pack" v-if="this.packages.find(x => x.code==donation.packagecode)!=null && packages.find(x => x.code==donation.packagecode).pack!=null" :style="'background-image:url('+packages.find(x => x.code==donation.packagecode).pack.image+')'"></div>
		</div>
		<div class="summary-pack" :class="packages.find(x => x.code==donation.packagecode)!=null && packages.find(x => x.code==donation.packagecode).toy!=null ? 'has-toy' : ''" v-if="packages.length > 1">
			<div class="toy" :style="packages.find(x => x.code==donation.packagecode)!=null && packages.find(x => x.code==donation.packagecode).toy!=null ? 'background-image:url('+packages.find(x => x.code==donation.packagecode).toy.image+')' : ''"></div>
		</div>
		<div class="items">
			<p class="product">{{donation.productname}}</p>
			<p class="amount">${{donation.amount}}</p>
			<p class="frequency">
        <template v-if="donation.type === 'Regular'">
            Monthly
        </template>
        <template v-else-if="donation.type === 'Single'">
   One-off
</template>
<template v-else-if="donation.type === 'Annual'">
   Annually
</template>
</p>
		</div>
	</div>

<h2>Enter payment details</h2>
<div class="iframe-loader">
<iframe ref="frame" frameborder="0" @load="load" v-if="donation.url" scrolling="no" :src="donation.url"></iframe>
    </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      isiframeLoading: false
    };
  },
  computed: mapState({
    donation: state => state.donation.donation,
    packages: state => state.product.packagesProduct
  }),
  methods: {
    load: function() {
      this.isiframeLoading = true;
      console.log("src", this.donation.url);
      console.log("is loaded", this.isiframeLoading);
    }
  }
};
</script>


// WEBPACK FOOTER //
// Step3.vue?0b2963b4